import { useState } from 'react';

import { Form } from '@app/components/common/form/form';
import { useAlert, useApi, useEntityState } from '@app/hooks';
import { SwitchField, TextField } from '@app/components/common';
import { Level } from '@app/api/models/structure';
import { QueryDraggableTable } from '@app/components/common/table';


type LevelFormProps = {
  initial?: Level;
  onSubmit?(instance: Partial<Level>): Promise<void>;
  onCancel?(): void;
};

export const LevelForm = ({
  initial,
  onSubmit,
  onCancel,
}: LevelFormProps) => {
  const { info, error } = useAlert();
  const api = useApi();
  const { refetch } = QueryDraggableTable.useQueryTable();
  const [instance, onChange] = useEntityState<Level>(initial);

  const onSubmitForm = async (instance: Partial<Level>) => {
    let response;

    if (initial) {
      response = await api.structure.updateLevel({
        id: instance.id,
        name: instance.name,
        value: instance.value,
        is_active: instance.is_active,
      });
    } else {

      response = await api.structure.getLevels({
        filter: {},
        sort: '+value',
        limit: 1,
        offset: 0,
      });
  
      if (response.code === 200) {
        instance.value = (response.data.data[0]?.value || 10100) - 100;
      } else {
        error(response.message);
        return;
      }

      response = await api.structure.createLevel({
        name: instance.name,
        value: instance.value,
      });
    }
    if (response?.code === 200) {
      await refetch();
      info(response.message);
      onSubmit(instance);
    }
  };
  
  return <Form
    instance={instance}
    onSubmit={onSubmitForm}
    onCancel={onCancel}
    onChange={onChange}
  >
    <Form.Item
      label="Наименование"
      field='name'
      required
      component={TextField}
      span={{ md: 12 }}
    />
    {initial && <Form.Item
      label="Активность"
      field='is_active'
      component={SwitchField}
      span={{ md: 12 }}
    />}
  </Form>;
};